import { Errors } from '../../../types';
import { useAuthApi } from '../useAuthApi';

export type ResetPasswordRequest = {
  token: string;
  emailAddress: string;
  password: string;
}

export type ResetPasswordResponse = ResetPasswordRequest & {
  id: string;
  errors?: Errors;
}

const callApi = async (_responseCall: any, apiCall: any) => (await apiCall).data;

export function useAuthResetPasswordApi() {
  const { post } = useAuthApi(undefined, callApi);

  return {
    post: (body: ResetPasswordRequest): Promise<ResetPasswordResponse> => post('user/reset-forgotten-password', body),
  };
}
